import styled from 'styled-components'

const Main = styled.div`
  padding: 0 .6cm;
`

export default Main
